import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Internist icon
 *
 * @category Medical
 */
const Internist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.092 14.537c-1.58-1.68-3.36-3.38-5.03-5.07-1.92-1.86-3.62-4.14-6.45-4.48-5.36-.74-9.32 5.62-6.11 10.2.44.72.14 1.33-.45 1.82-1.49 1.3-2.26 3.19-1.98 5.23.53 4.37 6.49 6.6 9.72 3.14.39-.38.76-.92 1.3-.96.46-.04 1.02.29 1.47.49 6.46 3 12.41-4.86 7.64-10.23l-.12-.14zm-16.41.7c-.94-.8-1.34-2.27-1.38-3.43-.05-1.56.52-3.15 1.63-4.26 1.42-1.41 3.58-2.03 5.51-1.42.33.11.66.25.96.42.81.46 1.52 1.09 2.19 1.74.73.71 1.358 1.339 1.968 2.159.52.71-.12 1.106-.6 1.585-.45.45-1.029 1.072-1.479 1.522-.91.91-1.589 1.734-2.499 2.644-.16.16-.33.33-.54.42-.28.12-.61.08-.9-.02-.6-.2-.588-.393-1.868-.733s-1.412.073-2.122-.147c-.33-.1-.61-.27-.86-.48zm2.25 1.4c1.74.03 3.65 1.31 4.31 3 .18.43.24.83.04 1.03-.19.21-.62.22-1.08.21h-4.94c-1.31-.03-2.2.07-2.96-.05-.36-.2-.21-.6-.08-1.07.6-1.83 2.72-3.15 4.55-3.12h.17zm-.45 9.44c-1.82-.09-3.77-1.43-4.33-3.2-.05-.25-.13-.59.1-.77 1-.58 2.4-.14 3.51-.26 1.67.04 3.61-.16 5.19.06 1.02.14.22 1.53-.39 2.35-.89 1.14-2.63 1.87-3.94 1.82zm13.79-2.94c-1.88 1.79-5.12 1.99-7.17.4-.52-.36-.8-.91-.77-1.54.09-1.34-.27-2.8-1.04-3.9-.28-.4-.31-.86.09-1.2 1.32-1.29 4.49-4.49 5.21-5.12a.3.3 0 0 1 .25-.02c1.45 1.19 3.02 2.76 4.22 4.23 1.5 2.12 1.18 5.22-.66 7.03l-.12.12z"
        />
      </svg>
    );
  }
);

Internist.displayName = 'Internist';

export { Internist };
